import { useDraggable } from '@dnd-kit/core';
import { createContext } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

const GenericDragContext = createContext(null);
function GenericDragContainer({
  id,
  translate,
  children
}) {
  const draggable = useDraggable({
    id: `${id}-draggable`
  });
  return jsx(GenericDragContext.Provider, {
    value: {
      ...draggable,
      translate
    },
    children: children
  });
}

export { GenericDragContext, GenericDragContainer as default };
